import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private authFackservice: AuthfakeauthenticationService
    ) { }

    canActivate(
      
      route: ActivatedRouteSnapshot, 
      state: RouterStateSnapshot
    
    
    ) {

        const currentPatientString = localStorage.getItem('currentPatient');

        if (currentPatientString) {
          try {
            const currentPatient = JSON.parse(currentPatientString);
            // Aquí puedes agregar más validaciones si es necesario
            // Por ejemplo, verificar si hay un token o si el objeto tiene ciertas propiedades
            if (currentPatient && currentPatient.userId) {  // Asumiendo que un paciente válido tiene un id
              return true;
            }
          } catch (error) {
            console.error('Error al parsear currentPatient:', error);
          }
        }
        this.router.navigate(['/account/login']);  // O a donde prefieras redirigir
        return false;



    }
}
